import { CButton, CNav, CNavItem, CNavLink } from "@coreui/react"
import React, { useEffect } from "react"
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import AntdTable from "src/components/AntdTable/Table"
import {
  deleteAbonementClub,
  editAbonementClub,
  getAbonementListClubItems,
  getAbonementListClubServices,
  getAbonementsListClubs,
  getAbonementsListClubsById,
  getClubs,
  AbonementStructure,
  deleteAbonementStructure,
} from "src/store/Slices/AbonementsSlice"
import AddNewAbonementCost from "../Modals/AddNewAbonementCost"
import { openNotification } from "src/components/helpers/notification"
import { Button, Dropdown, Input, Select, Space, Switch } from "antd"
import SureModal from "src/components/Modals/SureModal"
import { DownOutlined, SearchOutlined } from "@ant-design/icons"
import EditNewAbonementCost from "../Modals/EditNewAbonementCost"
import { useRef } from "react"
import { DeleteOutlined } from "@ant-design/icons"
import AddNewAbonementStructure from "../Modals/AddNewAbonementStructure"
import EditNewAbonementStructure from "../Modals/EditNewAbonementStructure"

const AbonementsCost = ({
  abonementStructureInfo,
  setAbonementStructureInfo,
  setAbonementCostInfo,
  abonementCostInfo,
  abonementInfo,
  mnemo,
}) => {
  // HELPERS
  const dispatch = useDispatch()

  const options = [
    { label: "Да", value: true },
    { label: "Нет", value: false },
  ]

  // STATE
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(5)
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [isDeleted, setIsDeleted] = useState(false)
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
  const [isOpenEditModal, setIsOpenEditModal] = useState(false)
  const [selectedKeys, setSelectedKyes] = useState("")
  const [dataIndex, setDataIndex] = useState("")
  const [sortByIdFrom, setSortByIdFrom] = useState()
  const [sortByIdTo, setSortByIdTo] = useState()
  const [sortByClub, setSortByClub] = useState()
  const [sortByPriceFrom, setSortByPriceFrom] = useState()
  const [sortByPriceTo, setSortByPriceTo] = useState()
  const [sortByMonthsFrom, setSortByMonthsFrom] = useState()
  const [sortByMonthsTo, setSortByMonthsTo] = useState()
  const [sortByDaysFreezeFrom, setSortByDaysFreezeFrom] = useState()
  const [sortByDaysFreezeTo, setSortByDaysFreezeTo] = useState()
  const [sortByHasSubscribtion, setSortByHasSubscribtion] = useState([])
  const [sortByIsWhatsApp, setSortByIsWhatsApp] = useState([])
  const [sortByMainAbonement, setSortByMainAbonement] = useState([])
  const [sortByDeferred, setSortByDeferred] = useState([])
  const [filterPayload, setFilterPayload] = useState({})
  const [selectedRecordId, setSelectedRecordId] = useState(null)
  const [selectedSuitableFor, setSelectedSuitableFor] = useState("")
  const [isActive, setIsActive] = useState(true)
  const [tab, setTab] = useState("Стоимость пакета")
  const [isOpenAbonementItemModal, setIsOpenAbonementItemModal] =
    useState(false)
  const [isOpenEditAbonementItemModal, setIsOpenEditAbonementItemModal] =
    useState(false)
  const [sortByIdFromStructure, setSortByIdFromStructure] = useState()
  const [sortByIdToStructure, setSortByIdToStructure] = useState()
  const [sortByItemName, setSortByItemName] = useState()
  const [sortByItemDescription, setSortByItemDescription] = useState()
  // REF
  const searchInput = useRef(null)

  // STORE
  const abonementsClubsList = useSelector(
    (state) => state.AbonementsSlice.abonementsClubsList
  )
  const abonementsClubsListLoading = useSelector(
    (state) => state.AbonementsSlice.abonementsClubsListLoading
  )
  const abonementClubs = useSelector(
    (state) => state.AbonementsSlice.abonementClubs
  )

  const AbonementStructureLoading = useSelector(
    (state) => state.AbonementsSlice.AbonementStructureLoading
  )

  const abonementStructure = useSelector(
    (state) => state.AbonementsSlice.abonementStructure
  )

  useEffect(() => {
    if (abonementInfo?.id) {
      dispatch(
        AbonementStructure({
          abonementId: abonementInfo.id,
        })
      )
    }
  }, [abonementInfo?.id])

  const getMenuItems = (record) => {
    const isSystemAbonement = abonementInfo?.name === "SYSTEM"

    const menuItems = []

    if (tab === "Состав абонемента") {
      menuItems.push(
        {
          key: "1",
          label: "Редактировать",
          onClick: () => {
            setAbonementStructureInfo(record)
            setIsOpenEditAbonementItemModal(true)
          },
        },
        {
          key: "2",
          label: "Удалить",
          onClick: () => {
            setAbonementStructureInfo(record)
            setIsOpenDeleteModal(true)
          },
        }
      )
    } else {
      if (!isSystemAbonement) {
        menuItems.push({
          key: "1",
          label: "Редактировать",
          onClick: () => {
            setAbonementCostInfo(record)
            setIsOpenEditModal(true)
          },
        })
      }

      menuItems.push({
        key: "2",
        label: "Удалить",
        onClick: () => {
          setAbonementCostInfo(record)
          setIsOpenDeleteModal(true)
        },
      })
    }

    return menuItems
  }

  const handleDelete = () => {
    if (tab === "Состав абонемента") {
      onClickDeleteStructure()
    } else {
      onClickDeleteCost()
    }
  }

  const getSuitableForById = (id) => {
    if (!id || !abonementsClubsList?.data?.value?.rows) return ""

    const record = abonementsClubsList.data.value.rows.find(
      (row) => row.id === id
    )
    return record?.suitableFor || ""
  }

  useEffect(() => {
    if (selectedRecordId) {
      const suitableFor = getSuitableForById(selectedRecordId)
      setSelectedSuitableFor(suitableFor)
      console.log("suitableFor для выбранной записи:", suitableFor)
    }
  }, [selectedRecordId, abonementsClubsList])

  useEffect(() => {
    dispatch(getClubs())
  }, [])

  // FUNCTIONS
  const title = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "10px",
        }}
      >
        <CNav variant='tabs'>
          <CNavItem>
            <CNavLink
              style={{ cursor: "pointer" }}
              onClick={() => setTab("Стоимость пакета")}
              active={tab === "Стоимость пакета"}
            >
              Стоимость пакета
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink
              style={{ cursor: "pointer" }}
              onClick={() => setTab("Состав абонемента")}
              active={tab === "Состав абонемента"}
            >
              Состав абонемента
            </CNavLink>
          </CNavItem>
        </CNav>

        {tab === "Стоимость пакета" ? (
          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <Switch
                disabled={
                  !mnemo?.children
                    ?.find((el) => el.name === "Абонемент-клубы")
                    ?.children.find((ele) => ele.mnemo === "isDeletedBtn")
                }
                defaultValue={isDeleted}
                checkedChildren={<DeleteOutlined />}
                unCheckedChildren={<DeleteOutlined />}
                onChange={() => {
                  setIsDeleted(!isDeleted)
                }}
              />
              {!isDeleted && (
                <CButton
                  disabled={
                    !mnemo?.children
                      ?.find((el) => el.name === "Абонемент-клубы")
                      ?.children.find((ele) => ele.mnemo === "insertBtn") ||
                    abonementInfo?.name === "SYSTEM"
                  }
                  size='sm'
                  className='text-light'
                  onClick={() => {
                    setIsOpenModal(true)
                  }}
                >
                  Добавить
                </CButton>
              )}
            </div>
          </div>
        ) : tab === "Состав абонемента" ? (
          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              {!isDeleted && (
                <CButton
                  disabled={
                    !mnemo?.children
                      ?.find((el) => el.name === "Абонемент-клубы")
                      ?.children.find((ele) => ele.mnemo === "insertBtn") ||
                    abonementInfo?.name === "SYSTEM"
                  }
                  size='sm'
                  className='text-light'
                  onClick={() => {
                    setIsOpenAbonementItemModal(true)
                  }}
                >
                  Добавить
                </CButton>
              )}
            </div>
          </div>
        ) : null}

        {/* <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <Switch
            disabled={
              !mnemo?.children
                ?.find((el) => el.name === "Абонемент-клубы")
                ?.children.find((ele) => ele.mnemo === "isDeletedBtn")
            }
            defaultValue={isDeleted}
            checkedChildren={<DeleteOutlined />}
            unCheckedChildren={<DeleteOutlined />}
            onChange={() => {
              setIsDeleted(!isDeleted)
            }}
          />
          {!isDeleted && (
            <CButton
              disabled={
                !mnemo?.children
                  ?.find((el) => el.name === "Абонемент-клубы")
                  ?.children.find((ele) => ele.mnemo === "insertBtn") ||
                abonementInfo?.name === "SYSTEM"
              }
              size='sm'
              className='text-light'
              onClick={() => {
                setIsOpenModal(true)
              }}
            >
              Добавить
            </CButton>
          )}
        </div> */}
      </div>
    )
  }

  const handleReset = (clearFilters) => {
    setPage(1)
    setPageSize(20)
    clearFilters()
    setSortByIdFrom()
    setSortByIdTo()
    setDataIndex()
    setSelectedKyes()
    setSortByClub()
    setSortByPriceFrom()
    setSortByPriceTo()
    setSortByMonthsFrom()
    setSortByMonthsTo()
    setSortByDaysFreezeFrom()
    setSortByDaysFreezeTo()
    setSortByHasSubscribtion([])
    setSortByIsWhatsApp([])
    setSortByMainAbonement([])
    setSortByDeferred([])
    dispatch(
      getAbonementsListClubs({
        AbonementId: abonementInfo?.id,
      })
    )
  }

  const onClickSearchItem = (selectedKeys, dataIndex) => {
    setPage(1)
    setPageSize(20)
    setSelectedKyes(selectedKeys[0])
    setDataIndex(dataIndex)
    dispatch(
      getAbonementsListClubs({
        AbonementId: abonementInfo?.id,
        isDeleted: isDeleted,
        idFrom: sortByIdFrom,
        idTo: sortByIdTo,
        clubId: sortByClub,
        priceFrom: sortByPriceFrom,
        priceTo: sortByPriceTo,
        monthCountFrom: sortByMonthsFrom,
        monthCountTo: sortByMonthsTo,
        frostDaysFrom: sortByDaysFreezeFrom,
        frostDaysTo: sortByDaysFreezeTo,
        hasSubscription: sortByHasSubscribtion[0],
        isWhatsApp: sortByIsWhatsApp[0],
        isPrimary: sortByMainAbonement[0],
        deferredPurchaseAvailable: sortByDeferred[0],
      })
    )
  }

  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <div>
          {title !== "№" &&
            title !== "Клуб" &&
            title !== "Цена" &&
            title !== "Кол-во месяцев" &&
            title !== "Дней заморозки" &&
            title !== "Подписка" &&
            title !== "Главный абонемент" &&
            title !== "Можно отложить покупку" && (
              <Input
                ref={searchInput}
                placeholder={`Искать ${title}`}
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() => onClickSearchItem(selectedKeys, dataIndex)}
                style={{
                  marginBottom: 8,
                  display: "block",
                }}
              />
            )}
          {title === "№" && (
            <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
              <Input
                placeholder='От'
                type='number'
                value={sortByIdFrom}
                onChange={(e) => setSortByIdFrom(e.currentTarget.value)}
              />
              <Input
                placeholder='До'
                type='number'
                value={sortByIdTo}
                onChange={(e) => setSortByIdTo(e.currentTarget.value)}
              />
            </div>
          )}
          {title === "Клуб" && (
            <div>
              <Select
                style={{ width: "100%", marginBottom: "8px" }}
                placeholder='Выбрать'
                onClick={() => dispatch(getClubs())}
                options={abonementClubs?.data?.value}
                value={sortByClub}
                onChange={(e) => setSortByClub(e)}
              />
            </div>
          )}
          {title === "Цена" && (
            <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
              <Input
                placeholder='От'
                type='number'
                value={sortByPriceFrom}
                onChange={(e) => setSortByPriceFrom(e.currentTarget.value)}
              />
              <Input
                placeholder='До'
                type='number'
                value={sortByPriceTo}
                onChange={(e) => setSortByPriceTo(e.currentTarget.value)}
              />
            </div>
          )}
          {title === "Кол-во месяцев" && (
            <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
              <Input
                placeholder='От'
                type='number'
                value={sortByMonthsFrom}
                onChange={(e) => setSortByMonthsFrom(e.currentTarget.value)}
              />
              <Input
                placeholder='До'
                type='number'
                value={sortByMonthsTo}
                onChange={(e) => setSortByMonthsTo(e.currentTarget.value)}
              />
            </div>
          )}
          {title === "Дней заморозки" && (
            <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
              <Input
                placeholder='От'
                type='number'
                value={sortByDaysFreezeFrom}
                onChange={(e) => setSortByDaysFreezeFrom(e.currentTarget.value)}
              />
              <Input
                placeholder='До'
                type='number'
                value={sortByDaysFreezeTo}
                onChange={(e) => setSortByDaysFreezeTo(e.currentTarget.value)}
              />
            </div>
          )}
          {title === "Подписка" && (
            <div>
              <Select
                style={{ width: "100%", marginBottom: "8px" }}
                options={options}
                onChange={(e) => setSortByHasSubscribtion([e])}
                value={sortByHasSubscribtion[0]}
                placeholder='Выбрать'
              />
            </div>
          )}
          {title === "Главный абонемент" && (
            <div>
              <Select
                style={{ width: "100%", marginBottom: "8px" }}
                options={options}
                onChange={(e) => setSortByMainAbonement([e])}
                value={sortByMainAbonement[0]}
                placeholder='Выбрать'
              />
            </div>
          )}
          {title === "Можно отложить покупку" && (
            <div>
              <Select
                style={{ width: "100%", marginBottom: "8px" }}
                options={options}
                onChange={(e) => setSortByDeferred([e])}
                value={sortByDeferred[0]}
                placeholder='Выбрать'
              />
            </div>
          )}
        </div>
        <Space>
          <Button
            type='primary'
            onClick={() => onClickSearchItem(selectedKeys, dataIndex)}
            icon={<SearchOutlined />}
            size='small'
            style={{
              width: 90,
            }}
          >
            Искать
          </Button>
          <Button
            onClick={() => {
              if (clearFilters) {
                handleReset(clearFilters)
              }
            }}
            size='small'
            style={{
              width: 90,
            }}
          >
            Сбросить
          </Button>
          <Button
            type='link'
            size='small'
            onClick={() => {
              close()
            }}
          >
            Закрыть
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1677ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100)
      }
    },
    render: (text) => text,
  })

  const onClickRowOne = (record) => {
    setAbonementCostInfo(record)
    setSelectedRecordId(record.id)

    console.log("suitableFor из записи:", record.suitableFor)

    dispatch(getAbonementListClubItems({ AbonementClubId: record.id }))
    dispatch(getAbonementListClubServices({ AbonementClubId: record.id }))
    dispatch(getAbonementsListClubsById(record.id))
  }

  const rowClassName = (record) => {
    return record?.key === abonementCostInfo?.key ? "selected-row" : ""
  }

  const onClickDeleteCost = () => {
    dispatch(
      deleteAbonementClub({
        abonementClubId: abonementCostInfo.id,
      })
    ).then(() => {
      dispatch(getAbonementsListClubs({ AbonementId: abonementInfo?.id }))
      setIsOpenDeleteModal(false)
    })
  }

  const onClickDeleteStructure = () => {
  dispatch(
    deleteAbonementStructure({
      tid: abonementStructureInfo.id,
    })
  ).then(() => {
    if (abonementInfo?.id) {
      dispatch(
        AbonementStructure({
          abonementId: abonementInfo.id,
          count: pageSize,
          offset: pageSize * (page - 1),
          idFrom: sortByIdFromStructure,
          idTo: sortByIdToStructure,
          itemName: sortByItemName,
          itemDescription: sortByItemDescription,
        })
      )
    }
    setIsOpenDeleteModal(false)
  })
}

  const handleTableChange = (pagination, filters, sorter) => {
    dispatch(
      getAbonementsListClubs({
        AbonementId: abonementInfo?.id,
        count: pagination.pageSize,
        offset: pagination.pageSize * (pagination.current - 1),
        orderBy: sorter?.column?.dataIndex,
        isDesc: sorter.order
          ? sorter.order === "ascend"
            ? true
            : false
          : undefined,
        isDeleted: isDeleted,
        idFrom: sortByIdFrom,
        idTo: sortByIdTo,
        clubId: sortByClub,
        priceFrom: sortByPriceFrom,
        priceTo: sortByPriceTo,
        monthCountFrom: sortByMonthsFrom,
        monthCountTo: sortByMonthsTo,
        frostDaysFrom: sortByDaysFreezeFrom,
        frostDaysTo: sortByDaysFreezeTo,
        hasSubscription: sortByHasSubscribtion[0],
        isWhatsApp: sortByIsWhatsApp[0],
        isPrimary: sortByMainAbonement[0],
        deferredPurchaseAvailable: sortByDeferred[0],
      })
    )
    setFilterPayload({
      AbonementId: abonementInfo?.id,
      count: pagination.pageSize,
      offset: pagination.pageSize * (pagination.current - 1),
      orderBy: sorter?.column?.dataIndex,
      isDesc: sorter.order
        ? sorter.order === "ascend"
          ? true
          : false
        : undefined,
      isDeleted: isDeleted,
      idFrom: sortByIdFrom,
      idTo: sortByIdTo,
      clubId: sortByClub,
      priceFrom: sortByPriceFrom,
      priceTo: sortByPriceTo,
      monthCountFrom: sortByMonthsFrom,
      monthCountTo: sortByMonthsTo,
      frostDaysFrom: sortByDaysFreezeFrom,
      frostDaysTo: sortByDaysFreezeTo,
      hasSubscription: sortByHasSubscribtion[0],
      isWhatsApp: sortByIsWhatsApp[0],
      isPrimary: sortByMainAbonement[0],
      deferredPurchaseAvailable: sortByDeferred[0],
    })
    setPage(pagination.current)
    setPageSize(pagination.pageSize)
  }

  const changeSubscribe = (element) => {
    dispatch(
      editAbonementClub({
        id: element.id,
        hasSubscription: !element.hasSubscription,
      })
    ).then(() => {
      dispatch(
        getAbonementsListClubs({
          AbonementId: abonementInfo?.id,
          count: pageSize,
          offset: pageSize * (page - 1),
          isDeleted: isDeleted,
          idFrom: sortByIdFrom,
          idTo: sortByIdTo,
          clubId: sortByClub,
          priceFrom: sortByPriceFrom,
          priceTo: sortByPriceTo,
          monthCountFrom: sortByMonthsFrom,
          monthCountTo: sortByMonthsTo,
          frostDaysFrom: sortByDaysFreezeFrom,
          frostDaysTo: sortByDaysFreezeTo,
          hasSubscription: sortByHasSubscribtion[0],
          isWhatsApp: sortByIsWhatsApp[0],
          isPrimary: sortByMainAbonement[0],
          deferredPurchaseAvailable: sortByDeferred[0],
        })
      )
    })
  }

  const onClickSearchItemStructure = (selectedKeys, dataIndex) => {
    setPage(1)
    setPageSize(20)
    setSelectedKyes(selectedKeys[0])
    setDataIndex(dataIndex)

    if (abonementInfo?.id) {
      dispatch(
        AbonementStructure({
          abonementId: abonementInfo.id,
          idFrom: sortByIdFromStructure,
          idTo: sortByIdToStructure,
          itemName: sortByItemName,
          itemDescription: sortByItemDescription,
        })
      )
    }
  }

  const handleTableChangeStructure = (pagination, filters, sorter) => {
  if (abonementInfo?.id) {
    dispatch(
      AbonementStructure({
        abonementId: abonementInfo.id,
        count: pagination.pageSize,
        offset: pagination.pageSize * (pagination.current - 1),
        orderBy: sorter?.column?.dataIndex,
        isDesc: sorter.order
          ? sorter.order === "ascend"
            ? false
            : true
          : undefined,
        idFrom: sortByIdFromStructure,
        idTo: sortByIdToStructure,
        itemName: sortByItemName,
        itemDescription: sortByItemDescription,
      })
    )
  }
  setPage(pagination.current)
  setPageSize(pagination.pageSize)
}

  const getColumnSearchPropsForStructure = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <div>
          {title !== "№" && 
          title !== "Имя элемента" && 
          title !== "Описание элемента" && (
            <Input
              ref={searchInput}
              placeholder={`Искать ${title}`}
              value={selectedKeys[0]}
              onChange={(e) =>
                setSelectedKeys(e.target.value ? [e.target.value] : [])
              }
              onPressEnter={() =>
                onClickSearchItemStructure(selectedKeys, dataIndex)
              }
              style={{
                marginBottom: 8,
                display: "block",
              }}
            />
          )}

          {title === "№" && (
            <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
              <Input
                placeholder='От'
                type='number'
                value={sortByIdFromStructure}
                onChange={(e) =>
                  setSortByIdFromStructure(e.currentTarget.value)
                }
              />
              <Input
                placeholder='До'
                type='number'
                value={sortByIdToStructure}
                onChange={(e) => setSortByIdToStructure(e.currentTarget.value)}
              />
            </div>
          )}

          {title === "Имя элемента" && (
            <Input
              placeholder='Искать по названию'
              value={sortByItemName}
              onChange={(e) => setSortByItemName(e.target.value)}
              style={{
                marginBottom: 8,
                display: "block",
              }}
            />
          )}

          {title === "Описание элемента" && (
            <Input
              placeholder='Искать по описанию'
              value={sortByItemDescription}
              onChange={(e) => setSortByItemDescription(e.target.value)}
              style={{
                marginBottom: 8,
                display: "block",
              }}
            />
          )}
        </div>
        <Space>
          <Button
            type='primary'
            onClick={() => onClickSearchItemStructure(selectedKeys, dataIndex)}
            icon={<SearchOutlined />}
            size='small'
            style={{
              width: 90,
            }}
          >
            Искать
          </Button>
          <Button
            onClick={() => {
              if (clearFilters) {
                handleResetStructure(clearFilters)
              }
            }}
            size='small'
            style={{
              width: 90,
            }}
          >
            Сбросить
          </Button>
          <Button
            type='link'
            size='small'
            onClick={() => {
              close()
            }}
          >
            Закрыть
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1677ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100)
      }
    },
    render: (text) => text || "-",
  })

  const handleResetStructure = (clearFilters) => {
    setPage(1)
    setPageSize(20)
    clearFilters()
    setSortByIdFromStructure()
    setSortByIdToStructure()
    setSortByItemName()
    setSortByItemDescription()
    setDataIndex()
    setSelectedKyes()

    if (abonementInfo?.id) {
      dispatch(
        AbonementStructure({
          abonementId: abonementInfo.id,
        })
      )
    }
  }

  const changeWhatsApp = (element) => {
    dispatch(
      editAbonementClub({
        id: element.id,
        isWhatsApp: !element.isWhatsApp,
      })
    ).then(() => {
      dispatch(
        getAbonementsListClubs({
          AbonementId: abonementInfo?.id,
          count: pageSize,
          offset: pageSize * (page - 1),
          isDeleted: isDeleted,
          idFrom: sortByIdFrom,
          idTo: sortByIdTo,
          clubId: sortByClub,
          priceFrom: sortByPriceFrom,
          priceTo: sortByPriceTo,
          monthCountFrom: sortByMonthsFrom,
          monthCountTo: sortByMonthsTo,
          frostDaysFrom: sortByDaysFreezeFrom,
          frostDaysTo: sortByDaysFreezeTo,
          hasSubscription: sortByHasSubscribtion[0],
          isWhatsApp: sortByIsWhatsApp[0],
          isPrimary: sortByMainAbonement[0],
          deferredPurchaseAvailable: sortByDeferred[0],
        })
      )
    })
  }

  const changeMainAbonement = (element) => {
    dispatch(
      editAbonementClub({
        id: element.id,
        isPrimary: !element.isPrimary,
      })
    ).then(() => {
      dispatch(
        getAbonementsListClubs({
          AbonementId: abonementInfo?.id,
          count: pageSize,
          offset: pageSize * (page - 1),
          isDeleted: isDeleted,
          idFrom: sortByIdFrom,
          idTo: sortByIdTo,
          clubId: sortByClub,
          priceFrom: sortByPriceFrom,
          priceTo: sortByPriceTo,
          monthCountFrom: sortByMonthsFrom,
          monthCountTo: sortByMonthsTo,
          frostDaysFrom: sortByDaysFreezeFrom,
          frostDaysTo: sortByDaysFreezeTo,
          hasSubscription: sortByHasSubscribtion[0],
          isPrimary: sortByMainAbonement[0],
          isWhatsApp: sortByIsWhatsApp[0],
          deferredPurchaseAvailable: sortByDeferred[0],
        })
      )
    })
  }

  const changeDeferredPurchaseAvailable = (element) => {
    dispatch(
      editAbonementClub({
        id: element.id,
        deferredPurchaseAvailable: !element.deferredPurchaseAvailable,
      })
    ).then(() => {
      dispatch(
        getAbonementsListClubs({
          AbonementId: abonementInfo?.id,
          count: pageSize,
          offset: pageSize * (page - 1),
          isDeleted: isDeleted,
          idFrom: sortByIdFrom,
          idTo: sortByIdTo,
          clubId: sortByClub,
          priceFrom: sortByPriceFrom,
          priceTo: sortByPriceTo,
          monthCountFrom: sortByMonthsFrom,
          monthCountTo: sortByMonthsTo,
          frostDaysFrom: sortByDaysFreezeFrom,
          frostDaysTo: sortByDaysFreezeTo,
          hasSubscription: sortByHasSubscribtion[0],
          isWhatsApp: sortByIsWhatsApp[0],
          isPrimary: sortByMainAbonement[0],
          deferredPurchaseAvailable: sortByDeferred[0],
        })
      )
    })
  }

  useEffect(() => {
    dispatch(
      getAbonementsListClubs({
        AbonementId: abonementInfo?.id,
        count: pageSize,
        offset: pageSize * (page - 1),
        isDeleted: isDeleted,
        idFrom: sortByIdFrom,
        idTo: sortByIdTo,
        clubId: sortByClub,
        priceFrom: sortByPriceFrom,
        priceTo: sortByPriceTo,
        monthCountFrom: sortByMonthsFrom,
        monthCountTo: sortByMonthsTo,
        frostDaysFrom: sortByDaysFreezeFrom,
        frostDaysTo: sortByDaysFreezeTo,
        hasSubscription: sortByHasSubscribtion[0],
        isWhatsApp: sortByIsWhatsApp[0],
        isPrimary: sortByMainAbonement[0],
        deferredPurchaseAvailable: sortByDeferred[0],
      })
    )
  }, [isDeleted])

  const formatedRows =
    abonementsClubsList?.data?.value?.rows?.map((element) => {
      return {
        ...element,
        isFrost: element.isFrost ? "Да" : "Нет",
        hasSubscription: (
          <Switch
            disabled={!mnemo?.children?.find((el) => el.mnemo === "abonements")}
            value={element.hasSubscription}
            onChange={() => changeSubscribe(element)}
          />
        ),
        isWhatsApp: (
          <Switch
            disabled={!mnemo?.children?.find((el) => el.mnemo === "abonements")}
            value={element.isWhatsApp}
            onChange={() => changeWhatsApp(element)}
          />
        ),
        isPrimary: (
          <Switch
            disabled={!mnemo?.children?.find((el) => el.mnemo === "abonements")}
            value={element.isPrimary}
            onChange={() => changeMainAbonement(element)}
          />
        ),
        deferredPurchaseAvailable: (
          <Switch
            disabled={!mnemo?.children?.find((el) => el.mnemo === "abonements")}
            value={element.deferredPurchaseAvailable}
            onChange={() => changeDeferredPurchaseAvailable(element)}
          />
        ),
      }
    }) || []

  return (
    <>
      <SureModal
        visible={isOpenDeleteModal}
        setVisible={setIsOpenDeleteModal}
        onClickYes={handleDelete}
      />
      <AddNewAbonementCost
        visible={isOpenModal}
        setVisible={setIsOpenModal}
        abonementInfo={abonementInfo}
        payload={filterPayload}
      />
      <EditNewAbonementCost
        visible={isOpenEditModal}
        setVisible={setIsOpenEditModal}
        abonementInfo={abonementInfo}
        abonementCostInfo={abonementCostInfo}
        payload={filterPayload}
      />
      <AddNewAbonementStructure
        visible={isOpenAbonementItemModal}
        setVisible={setIsOpenAbonementItemModal}
        abonementInfo={abonementInfo}
      />
      <EditNewAbonementStructure
        visible={isOpenEditAbonementItemModal}
        setVisible={setIsOpenEditAbonementItemModal}
        abonementInfo={abonementInfo}
        abonementStructureInfo={abonementStructureInfo}
        //payload={filterPayload}
      />

      {tab === "Стоимость пакета" ? (
        <AntdTable
          pageSize={pageSize}
          setPageSize={setPageSize}
          page={page}
          setPage={setPage}
          loading={abonementsClubsListLoading}
          columns={
            abonementsClubsList && [
              ...abonementsClubsList?.data?.value?.columns.map((element) => {
                return {
                  ...element,
                  ...getColumnSearchProps(element.dataIndex, element.title),
                }
              }),
              {
                title: "Для кого подходит",
                dataIndex: "suitableFor",
                key: "suitableFor",
                width: 300,
                render: (text) => text || "-",
              },
              {
                title: "Действия",
                key: "action",
                align: "center",
                render: (_, record) => (
                  <Dropdown
                    menu={{
                      items: getMenuItems(record),
                    }}
                    disabled={isDeleted}
                  >
                    <a className='text-primary text-decoration-none'>
                      Действия <DownOutlined />
                    </a>
                  </Dropdown>
                ),
                width: 100,
              },
            ]
          }
          rows={formatedRows}
          scroll={{ x: 0, y: 226 }}
          title={title}
          onClickRowOne={onClickRowOne}
          onChange={handleTableChange}
          total={abonementsClubsList?.data?.value?.totalCount}
          rowClassName={rowClassName}
        />
      ) : tab === "Состав абонемента" ? (
        <AntdTable
          pageSize={pageSize}
          setPageSize={setPageSize}
          page={page}
          setPage={setPage}
          loading={AbonementStructureLoading}
          columns={
            abonementStructure?.data?.data?.value?.columns
              ? [
                  ...abonementStructure.data.data.value.columns.map(
                    (element) => ({
                      ...element,
                      ...getColumnSearchPropsForStructure(
                        element.dataIndex,
                        element.title
                      ),
                      ...(element.dataIndex === "itemDescription"
                        ? {
                            render: (text, record) =>
                              record.serviceName || text || "-",
                          }
                        : {}),
                    })
                  ),
                  {
                    title: "Действия",
                    dataIndex: "action",
                    key: "action",
                    align: "center",
                    fixed: "right",
                    render: (_, record) => (
                      <Dropdown
                        menu={{
                          items: getMenuItems(record),
                        }}
                        disabled={isDeleted}
                      >
                        <a className='text-primary text-decoration-none'>
                          Действия <DownOutlined />
                        </a>
                      </Dropdown>
                    ),
                    width: 120,
                  },
                ]
              : []
          }
          rows={
            abonementStructure?.data?.data?.value?.rows?.map((element) => ({
              ...element,
            })) || []
          }
          scroll={{ x: 800, y: 226 }}
          title={title}
          onClickRowOne={() => {}}
          onChange={handleTableChangeStructure}
          total={abonementStructure?.data?.data?.value?.totalCount || 0}
          rowClassName={rowClassName}
        />
      ) : null}
    </>
  )
}

export default AbonementsCost
